// Local fallback only; the real translation comes from MTS common (Global group)
// 本地兜底翻译；线上翻译走 MTS common 的 Global 分组，本地仅在 CDN 缺词或失效时生效
export const Global = {
    LastLoginIp: '最近一次登录IP',
};
